export default "__VITE_ASSET__BVHDneoB__"